<template>
  <div>
    <div
      v-if="showFilters"
      class="md-layout-item md-size-100 display-flex gap-30 margin-top-40"
    >
      <md-field v-if="searchFields.meterType" class="input width-100">
        <md-select
          v-model="search.typeId"
          name="meterTypes"
          id="meterTypes"
          md-clearable
          :disabled="disabled"
        >
          <md-option
            v-for="type in meterTypes"
            :key="type.id"
            :value="type.id"
            >{{ type.displayString }}</md-option
          >
        </md-select>
      </md-field>

      <md-field v-if="searchFields.meterRef" class="input">
        <label class="label">{{ $t("activities.meterRef") }}</label>
        <md-input v-model="search.meterRef" :disabled="disabled" />
      </md-field>

      <md-field v-if="searchFields.employee" class="input">
        <label class="label">{{ $t("schedule.employee") }}</label>
        <md-input v-model="search.employee" :disabled="disabled" />
      </md-field>

      <md-button
        style="width: 40px; height: 40px"
        class="md-fab md-primary icon-button-size-40"
        @click="clearSearchFields"
        title="Clear search"
        :disabled="disabled"
      >
        <md-icon class="icon-button-size-40">clear</md-icon>
      </md-button>
    </div>

    <div
      v-if="showFilters && searchFields.showOnlyOwnMeters"
      class="md-layout-item md-size-100 display-flex gap-30 margin-top-40"
    >
      <md-switch v-model="search.trimMeters">
        {{ $t("common.showOwnMeters") }}
      </md-switch>
    </div>
  </div>
</template>

<script>
//******************
//           <SearchFields :meterTypes="meterTypes" :getMetersFunc="getMetersFunc" />
// *****************//
import debounce from "lodash.debounce";

export default {
  name: "SearchMetersDataGrid",
  components: {},
  props: {
    searchFunction: {
      type: Function,
      required: true,
    },
    meterTypes: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    searchFields: {
      type: Object,
      default: () => ({
        meterType: true,
        meterRef: true,
        employee: false,
        showOnlyOwnMeters: false,
      }),
    },
  },
  data: function () {
    return {
      search: {
        typeId: "",
        meterRef: "",
        employee: "",
        trimMeters: false,
      },
    };
  },
  computed: {
    showFilters: function () {
      return Object.values(this.searchFields).some((value) => value === true);
    },
  },
  watch: {
    search: {
      handler: function (val) {
        this.debouncedFunc();
      },
      deep: true,
    },
  },
  created() {
    this.debouncedFunc = debounce(() => this.searchFunction(this.search), 3500);
  },
  beforeUnmount() {
    this.debouncedFunc.cancel();
  },
  methods: {
    clearSearchFields() {
      this.search.typeId = "";
      this.search.meterRef = "";
      this.search.employee = "";
      this.search.trimMeters = false;

      this.debouncedFunc.cancel();
      this.searchFunction(this.search);
    },
  },
};
</script>
<style></style>
